module.exports = __webpack_public_path__ + "static/media/about-img.16d647e9.png";